<template>
	<section class="promotions main-content align-center">
		<div class="row row-header align-center">
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
			<div v-parse-links v-html="content" />
		</div>
		<div class="row promotions-row flex-row slide-row">
			<client-only>
				<nuxt-link
					v-for="room in items.slice(0, 5)"
					:key="room.ID"
					:to="localePath(`/${room.filename}`)"
					class="slick-item"
				>
					<div class="img-wrapper">
						<picture>
							<source
								v-if="room.imageOverviewPortraitWebp"
								:srcset="room.imageOverviewPortraitWebp"
								type="image/webp"
							/>
							<source :srcset="room.imageOverviewPortrait" />
							<img
								loading="lazy"
								:src="room.imageOverviewPortrait"
								:alt="room.imageOverviewPortraitAlt"
							/>
						</picture>
					</div>
					<div class="slick-slide-content">
						<div class="slick-slide-header">
							<span>
								<h3>{{ room.header }}</h3>
								<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
							</span>
							<div class="pax">
								<font-awesome-icon icon="fa-light fa-users" size="1x" />
								<span>{{ room.pax }}</span>
							</div>
						</div>
					</div>
				</nuxt-link>
			</client-only>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
	subtitle: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--primary-background-color);
}

.row-header {
	max-width: 980px;
}

.pax {
	color: #000;
	padding: 5px;
	border-left: 1px solid var(--subtitle-color);
	display: flex;
	flex-flow: row nowrap;

	span {
		font-size: 18px;
		margin: 0 0 0 8px;
	}

	svg {
		color: #000;
		font-size: 14px;
	}
}

.slick-item {
	width: 19%;
	margin: 0 1% 0 0;
}

.slick-slide-header {
	border-bottom: 1px solid var(--subtitle-color);
}

@media (max-width: 1440px) {
	.slick-item {
		width: 31%;
		margin: 0 1% 2%;
	}
}

@media (max-width: 1080px) {
	.slick-item {
		width: 48%;
		margin: 0 1% 2%;
	}
}
</style>
